// src/api/boot/boot.ts
import { api } from "../api";
import type { Profile } from "../profile/profile.types";
import type { PaymentInfo } from "../payments/payments.types";
import type { ConversationResponse } from "../chat/chat.types";

export interface BootResponse {
    profile: Profile;
    payment: PaymentInfo | null;
    canonical_conversation: ConversationResponse | null;
}

export const bootApi = {
    getMe: async (): Promise<BootResponse> => {
        const { data } = await api.get<BootResponse>("/boot/me");
        return data;
    },
};
